import _ from 'lodash';

export const createLoader = (actionName, resultName, canCancel = true) => {
  const loadingParamName = `${resultName}Waiting`;
  const loadedParamName = `${resultName}Loaded`;
  const errParamName = `${resultName}Error`;

  const loaderAction = {
    load: `${actionName}/LOAD`,
    success: `${actionName}/LOAD_SUCCESS`,
    fail: `${actionName}/LOAD_FAIL`,
  };

  loaderAction.actions = [loaderAction.load, loaderAction.success, loaderAction.fail];
  loaderAction.onLoadReducer = (state) => ({
    ...state,
    [loadingParamName]: true,
  });
  loaderAction.onSuccessReducer = (state, action) => ({
    ...state,
    [loadingParamName]: false,
    [loadedParamName]: true,
    [resultName]: action.result ? action.result : [],
  });
  loaderAction.onFailReducer = (state, action) => {
    let isWaiting = false;
    if (_.get(action, 'error.type') === 'canceled' && state[loadingParamName]) isWaiting = true;
    return {
      ...state,
      [loadingParamName]: isWaiting,
      [loadedParamName]: !isWaiting,
      [errParamName]: action.error,
    };
  };

  loaderAction.reducers = {
    [loaderAction.load]: loaderAction.onLoadReducer,
    [loaderAction.success]: loaderAction.onSuccessReducer,
    [loaderAction.fail]: loaderAction.onFailReducer,
  };

  const tokenTemplate = { cancel: _.noop };

  const formRequest = (method, allToken) => (url, payload) => {
    const payloadData = payload || {};
    const data = payloadData.data;
    const params = payloadData.params;
    let token;
    if (canCancel) {
      token = tokenTemplate;
      allToken.push(token);
    }
    return {
      types: loaderAction.actions,
      promise: (client) => client[method](url, { data, params }, token),
    };
  };

  const methods = ['get', 'put', 'post', 'del', 'patch'];
  _.forEach(methods, (method) => {
    const allToken = [tokenTemplate];
    loaderAction[method] = formRequest(method, allToken);
  });
  return loaderAction;
};
